import PendingTransferPayment from './PendingTransferPaymentContainer';

export default PendingTransferPayment;
